/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientSymptomHistories } from 'app/entities/patient-symptom-history/patient-symptom-history.reducer';
import { getEntities as getSymptomAttributes } from 'app/entities/symptom-attribute/symptom-attribute.reducer';
import { createEntity, getEntity, reset, updateEntity } from './patient-symptom-attribute.reducer';

export const PatientSymptomAttributeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientSymptomHistories = useAppSelector(state => state.patientSymptomHistory.entities);
  const symptomAttributes = useAppSelector(state => state.symptomAttribute.entities);
  const patientSymptomAttributeEntity = useAppSelector(state => state.patientSymptomAttribute.entity);
  const loading = useAppSelector(state => state.patientSymptomAttribute.loading);
  const updating = useAppSelector(state => state.patientSymptomAttribute.updating);
  const updateSuccess = useAppSelector(state => state.patientSymptomAttribute.updateSuccess);

  const handleClose = () => {
    navigate(`/patient-symptom-attribute${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientSymptomHistories({}));
    dispatch(getSymptomAttributes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.symptomOrder !== undefined && typeof values.symptomOrder !== 'number') {
      values.symptomOrder = Number(values.symptomOrder);
    }

    const entity = {
      ...patientSymptomAttributeEntity,
      ...values,
      symptomHistory: patientSymptomHistories.find(it => it.id.toString() === values.symptomHistory?.toString()),
      attribute: symptomAttributes.find(it => it.id.toString() === values.attribute?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...patientSymptomAttributeEntity,
          symptomHistory: patientSymptomAttributeEntity?.symptomHistory?.id,
          attribute: patientSymptomAttributeEntity?.attribute?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientSymptomAttribute.home.createOrEditLabel" data-cy="PatientSymptomAttributeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.home.createOrEditLabel">
              Create or edit a PatientSymptomAttribute
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-symptom-attribute-id"
                  label={translate('tinyMedicRestApp.patientSymptomAttribute.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientSymptomAttribute.resultValue')}
                id="patient-symptom-attribute-resultValue"
                name="resultValue"
                data-cy="resultValue"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientSymptomAttribute.active')}
                id="patient-symptom-attribute-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientSymptomAttribute.cursor')}
                id="patient-symptom-attribute-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientSymptomAttribute.lastUpdated')}
                id="patient-symptom-attribute-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientSymptomAttribute.microSec')}
                id="patient-symptom-attribute-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientSymptomAttribute.timestampEntry')}
                id="patient-symptom-attribute-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientSymptomAttribute.symptomOrder')}
                id="patient-symptom-attribute-symptomOrder"
                name="symptomOrder"
                data-cy="symptomOrder"
                type="text"
              />
              <ValidatedField
                id="patient-symptom-attribute-symptomHistory"
                name="symptomHistory"
                data-cy="symptomHistory"
                label={translate('tinyMedicRestApp.patientSymptomAttribute.symptomHistory')}
                type="select"
              >
                <option value="" key="0" />
                {patientSymptomHistories
                  ? patientSymptomHistories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-symptom-attribute-attribute"
                name="attribute"
                data-cy="attribute"
                label={translate('tinyMedicRestApp.patientSymptomAttribute.attribute')}
                type="select"
              >
                <option value="" key="0" />
                {symptomAttributes
                  ? symptomAttributes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-symptom-attribute" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientSymptomAttributeUpdate;
